import React, {useEffect, useState} from 'react'
import {Layer, Rect} from 'react-konva'
import {ElementShapeType} from '../../../entities/project'
import {useStateWithRef} from '../../../hooks/useStateWithRef'
import type {KonvaNodeEvents} from 'react-konva'
import {Node as NodeRef, NodeConfig} from 'konva/lib/Node'
import {getRelativePointerPosition} from '../util'

export function RectToolLayer({
  onElementDrawn,
}: {
  onElementDrawn: (shape: {type: ElementShapeType; props: NodeConfig}) => void
}) {
  const [topLeftCorner, setTopLeftCorner, topLeftCornerRef] = useStateWithRef<{
    x: number
    y: number
  } | null>(null)
  const [dimensions, setDimensions, dimensionsRef] = useStateWithRef<{
    width: number
    height: number
  }>({
    width: 0,
    height: 0,
  })

  const layerRef = React.useRef<NodeRef>(null)

  useEffect(() => {
    const onMouseDown: KonvaNodeEvents['onMouseDown'] = (e) => {
      const {x, y} = getRelativePointerPosition(e.target)
      setTopLeftCorner({x, y})
    }

    const onMouseMove: KonvaNodeEvents['onMouseMove'] = (e) => {
      if (!topLeftCornerRef.current) {
        return
      }

      const {x, y} = topLeftCornerRef.current
      const {x: mouseX, y: mouseY} = getRelativePointerPosition(e.target)

      const width = mouseX - x
      const height = mouseY - y
      const rotation = 0

      setDimensions({
        width,
        height,
      })
    }

    const onMouseUp: KonvaNodeEvents['onMouseUp'] = (e) => {
      if (!topLeftCornerRef.current) {
        return
      }

      let x1 = topLeftCornerRef.current.x
      let x2 = x1 + dimensionsRef.current.width
      let y1 = topLeftCornerRef.current.y
      let y2 = y1 + dimensionsRef.current.height

      if (x1 > x2) {
        ;[x1, x2] = [x2, x1]
      }
      if (y1 > y2) {
        ;[y1, y2] = [y2, y1]
      }

      onElementDrawn({
        type: 'rect',
        props: {
          x: Math.floor(x1),
          y: Math.floor(y1),
          width: Math.floor(x2 - x1),
          height: Math.floor(y2 - y1),
        },
      })
      setTopLeftCorner(null)
    }

    const stage = layerRef.current.getStage()

    stage.on('mousedown', onMouseDown)
    stage.on('mousemove', onMouseMove)
    stage.on('mouseup', onMouseUp)

    return () => {
      if (stage) {
        stage.off('mousedown', onMouseDown)
        stage.off('mousemove', onMouseMove)
        stage.off('mouseup', onMouseUp)
      }
    }
  }, [onElementDrawn])

  return (
    <Layer ref={layerRef as any} opacity={0.7}>
      {topLeftCorner && (
        <Rect
          fill="blue"
          x={topLeftCorner.x}
          y={topLeftCorner.y}
          width={dimensions.width}
          height={dimensions.height}
        />
      )}
    </Layer>
  )
}
